import React from 'react';

const ToolsMethods = () => {
  const tools = [
    {
      name: "exSILentia",
      description: "Industry-leading SIL verification tool for safety instrumented systems",
      features: ["SIL calculations", "Proof test optimization", "Lifecycle cost analysis"],
      icon: "fas fa-calculator"
    },
    {
      name: "SLM (Safety Lifecycle Manager)",
      description: "Comprehensive safety lifecycle management platform",
      features: ["Document management", "Compliance tracking", "Audit trails"],
      icon: "fas fa-project-diagram"
    },
    {
      name: "Simulation Platforms",
      description: "Advanced modeling and simulation for safety system behavior",
      features: ["Dynamic modeling", "Scenario testing", "Performance prediction"],
      icon: "fas fa-chart-line"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Tools & Methods</h2>
          <p className="text-xl text-gray-600">State-of-the-art software and proven methodologies</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {tools.map((tool, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <i className={`${tool.icon} text-4xl text-blue-600 mb-4 block`}></i>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{tool.name}</h3>
              <p className="text-gray-600 mb-6">{tool.description}</p>
              <div className="space-y-2">
                {tool.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-gray-700">
                    <i className="fas fa-check-circle text-green-500 mr-2"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-white p-12 rounded-lg shadow-lg">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Proof-Testing Optimization</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-lg text-gray-600 mb-4">
                Our advanced methodologies optimize proof-testing intervals to balance safety requirements 
                with operational efficiency.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="fas fa-arrow-right text-blue-600 mr-3 mt-1"></i>
                  <span className="text-gray-700">Minimize production interruptions</span>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-arrow-right text-blue-600 mr-3 mt-1"></i>
                  <span className="text-gray-700">Maintain required SIL levels</span>
                </li>
                <li className="flex items-start">
                  <i className="fas fa-arrow-right text-blue-600 mr-3 mt-1"></i>
                  <span className="text-gray-700">Reduce lifecycle costs</span>
                </li>
              </ul>
            </div>
            <div>
              <img
                src="/assets/asset-22.jpg"
                alt="Software dashboard"
                className="rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolsMethods;
